// extracted by mini-css-extract-plugin
export default {"subscriptionList":"styles_subscriptionList__YTnFM"};